module.exports = __webpack_public_path__ + "248eb016e5a8b7ab57e0d59692d493d9.png";